import { getOverlayBonusWheelDescription } from 'Components/_brand/overlays/brandOverlaysLibrary';
import { basicChannel } from 'src/channels/basic.channel';
import styles from './WheelDescriptionBanner.module.scss';
import { t } from 'i18next';

export const WheelDescriptionBanner = ({ bundles }) => {
  return (
    <div className={styles.banner}>
      <div>
        <p className={styles.banner_title}>{t('wheel.page.banner.title')}</p>
        <p className={styles.banner_subtitle}>{t('wheel.page.banner.subtitle')}</p>
      </div>
      <button
        className={styles.banner_button}
        onClick={e => {
          getOverlayBonusWheelDescription({
            bundles,
            onClose: () => {
              basicChannel.send({
                action: 'close',
              });
            },
          });
        }}
      >
        {t('wheel.page.banner.button')}
      </button>
    </div>
  );
};
